import { isBefore } from 'date-fns';
import { localStorage, sessionStorage } from '../../storage';

const SESSION_CONTEXT_INFO = 'sessionContext';
const storage =
  process.env.APP_STORE === 'session' ? sessionStorage : localStorage;

const ttlInSecs = 14400000;

const now = function now() {
  return new Date();
};

export default {
  get: () => {
    if (storage.getItem(SESSION_CONTEXT_INFO)) {
      const entry = JSON.parse(storage.getItem(SESSION_CONTEXT_INFO));
      if (!entry) return null;
      if (entry.expire && isBefore(new Date(entry.expire), now())) {
        localStorage.removeItem(SESSION_CONTEXT_INFO);
        return null;
      }
      return entry;
    }
    return null;
  },

  set: session => {
    const ttlSession = {
      ...session,
      expire: now().getTime() + ttlInSecs * 1000
    };
    storage.setItem(SESSION_CONTEXT_INFO, JSON.stringify(ttlSession));
  }
};
